/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

// Simple bar
import SimpleBar from 'simplebar-react';

// MetisMenu
import MetisMenu from 'metismenujs';
import { withRouter, Link } from 'react-router-dom';

// i18n
import { withTranslation } from 'react-i18next';

import { Can } from '../../utilities/Can';
import bestBuyLogo from '../../assets/images/brands/best-buy.png';

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  // componentDidUpdate() {}
  scrollElement = (item) => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current) {
              this.refDiv.current.getScrollElement().scrollTop = currentPosition - 300;
            }
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = (item) => {
    item.classList.add('active');
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show');
    }

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show'); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add('mm-active'); // li
          parent3.childNodes[0].classList.add('mm-active'); // a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add('mm-show'); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add('mm-show'); // li
              parent5.childNodes[0].classList.add('mm-active'); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  initMenu() {
    // eslint-disable-next-line no-new
    new MetisMenu('#side-menu');
    let matchingMenuItem = null;
    const ul = document.getElementById('side-menu');
    const items = ul.getElementsByTagName('a');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  render() {
    return (
      <SimpleBar className="h-100" ref={this.refDiv}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <Can i="see" this="Sales">
              <li>
                <Link to="/sales">
                  <i className="mdi mdi-cash-register" />
                  <span>{this.props.t('Sales')}</span>
                </Link>
              </li>
            </Can>
            <Can i="see" this="Sales">
              <li>
                <Link to="/offers">
                  <i className="mdi mdi-file-document-edit" />
                  <span>{this.props.t('Offers')}</span>
                </Link>
              </li>
            </Can>

            <Can i="see" this="Items">
              <li>
                <Link to="/items">
                  <i className="bx bx-package" />
                  <span>{this.props.t('Items')}</span>
                </Link>
              </li>
            </Can>

            <Can i="see" this="Fuse">
              <li>
                <Link to="/fuse">
                  <i className="mdi mdi-fuse-blade" />
                  <span>{this.props.t('Fuse')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/fuse/workorders">{this.props.t('Workorders')}</Link>
                  </li>
                  <li>
                    <Link to="/fuse">{this.props.t('Families')}</Link>
                  </li>
                </ul>
              </li>
            </Can>

            <Can i="see" this="Listings">
              <li>
                <Link to="/listings">
                  <i className="far fa-newspaper" />
                  <span>{this.props.t('Listings')}</span>
                </Link>
              </li>
            </Can>

            <li className="menu-title">{this.props.t('Operations')}</li>

            <Can i="see" this="Sourcing">
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-handshake" />
                  <span>{this.props.t('Sourcing')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/sourcing">{this.props.t('Orders')}</Link>
                  </li>
                  <li>
                    <Link to="/sourcing/intake">{this.props.t('Sort')}</Link>
                  </li>
                  <li>
                    <Link to="/sourcing/trucks">{this.props.t('Trucks')}</Link>
                  </li>
                  <Can i="see" this="SuppliersAdmin">
                    <li>
                      <Link to="/sourcing/suppliers">{this.props.t('Suppliers')}</Link>
                    </li>
                    <li>
                      <Link to="/directory">{this.props.t('Directory')}</Link>
                    </li>
                  </Can>
                </ul>
              </li>
            </Can>

            <Can i="see" this="TVs">
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-television-clean" />
                  <span>{this.props.t('TVs')}</span>
                </Link>
                <ul className="sub-menu">
                  <Can i="see" this="TVsBrowse">
                    <li>
                      <Link to="/tvs">{this.props.t('Browse')}</Link>
                    </li>
                  </Can>
                  <Can i="see" this="TVsInduct">
                    <li>
                      <Link to="/tvs/induction">{this.props.t('Induction')}</Link>
                    </li>
                    <li>
                      <Link to="/tvs/pallets">{this.props.t('Processed Pallets')}</Link>
                    </li>
                    <li>
                      <Link to="/tvs/labels">{this.props.t('Labels')}</Link>
                    </li>
                  </Can>
                  <Can i="see" this="TVsTeardown">
                    <li>
                      <Link to="/tvs/teardown">{this.props.t('Teardown')}</Link>
                    </li>
                  </Can>
                  <Can i="see" this="TVsAdmin">
                    <li>
                      <Link to="/tvs/utilities">{this.props.t('Utilities')}</Link>
                    </li>
                  </Can>
                </ul>
              </li>
            </Can>

            <Can i="see" this="Customer Service">
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-headset" />
                  <span>{this.props.t('Customer Service')}</span>
                </Link>
                <ul className="sub-menu">
                  <Can i="see" this="Tech Support">
                    <li>
                      <Link to="/customer-service/tickets">{this.props.t('Tech Support')}</Link>
                    </li>
                  </Can>
                  <li>
                    <Link to="/customer-service/returns">{this.props.t('Returns')}</Link>
                  </li>
                  <li>
                    <Link to="/customer-service/amazon-gift-cards">
                      {this.props.t('Amazon Gift Cards')}
                    </Link>
                  </li>
                  <Can i="see" this="Returns Trends">
                    <li>
                      <Link to="/sales/returns">{this.props.t('Returns Trends')}</Link>
                    </li>
                  </Can>
                </ul>
              </li>
            </Can>

            <Can i="see" this="System">
              <li className="menu-title">{this.props.t('System')}</li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-api" />
                  <span>{this.props.t('Remote Services')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/bc">
                      <span className="mdi mdi-alpha-b-box-outline" />
                      {' '}
                      {this.props.t('BigCommerce')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/burnsville">
                      <span className="mdi mdi-alpha-b-box-outline" />
                      {' '}
                      {this.props.t('Burnsville')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ca">
                      <span className="mdi mdi-alpha-c-box" />
                      {' '}
                      {this.props.t('Channel Advisor')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/google/merchant">
                      <span className="mdi mdi-google" />
                      {' '}
                      {this.props.t('Google Merchant')}
                    </Link>
                  </li>
                  <Can i="see" this="API">
                    <li>
                      <Link to="/best-buy">
                        <img
                          src={bestBuyLogo}
                          alt=""
                          aria-hidden="true"
                          style={{
                            height: '18px',
                            marginRight: '0.35rem',
                            objectFit: 'contain',
                            verticalAlign: 'middle',
                            width: '20px',
                          }}
                        />
                        {this.props.t('Best Buy')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/es">
                        <span className="mdi mdi-search" />
                        {' '}
                        {this.props.t('Elastic Search')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/microsoft">
                        <span className="mdi mdi-microsoft" />
                        {' '}
                        {this.props.t('Microsoft')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/client-api">
                        <span className="mdi mdi-devices" />
                        {' '}
                        {this.props.t('Client API')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/partner-api">
                        <span className="mdi mdi-handshake" />
                        {' '}
                        {this.props.t('Partner API')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/ucp">
                        <span className="mdi mdi-cart-arrow-right" />
                        {' '}
                        {this.props.t('UCP Utilities')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/slack">
                        <span className="fab fa-slack" />
                        {' '}
                        {this.props.t('Slack')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/happy-returns">
                        <span className="mdi mdi-cash-refund" />
                        {' '}
                        {this.props.t('Happy Returns')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/sqtr/returns/import">
                        <span className="mdi mdi-file-upload-outline" />
                        {' '}
                        {this.props.t('Squaretrade Returns')}
                      </Link>
                    </li>
                  </Can>
                </ul>
              </li>
            </Can>

            <Can i="see" this="Logs">
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bxs-book-open" />
                  <span>{this.props.t('Logs')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/logs/exceptions">{this.props.t('Exceptions')}</Link>
                  </li>
                  <li>
                    <Link to="/logs/bc-fails">{this.props.t('BC Sync Failures')}</Link>
                  </li>
                  <li>
                    <Link to="/logs/pricing">{this.props.t('Price Stats')}</Link>
                  </li>
                </ul>
              </li>
            </Can>

            <Can i="see" this="SQL">
              <li>
                <Link to="/sql">
                  <i className="mdi mdi-database-search" />
                  <span>{this.props.t('SQL')}</span>
                </Link>
              </li>
            </Can>

            <Can i="see" this="Settings">
              <li>
                <Link to="/settings" className="has-arrow">
                  <i className="mdi mdi-cog" />
                  <span>{this.props.t('Settings')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/listings/trees">
                      <i className="mdi mdi-file-tree" />
                      <span>{this.props.t('Category Trees')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/profiles">
                      <i className="fas fa-stamp" />
                      <span>{this.props.t('Profiles')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/users">
                      <i className="mdi mdi-account-group" />
                      <span>{this.props.t('Users')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/printers">
                      <i className="mdi mdi-printer-settings" />
                      <span>{this.props.t('Printers')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/settings/utilities">
                      <i className="mdi mdi-tools" />
                      <span>{this.props.t('Utilities')}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            </Can>
          </ul>
        </div>
      </SimpleBar>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
